module.exports = __webpack_public_path__ + "img/f723a0ae2268825dfb0135f98a91772d.svg";